import { ReactNode } from "react";
import { cn } from "utils/styling";

const STATUS_CHIP_VARIANTS = {
  error: {
    bgClassName: "bg-core-mystic-red-50",
    borderColorClassName: "border-core-mystic-red-200",
    textClassName: "text-core-mystic-red-700",
  },
  info: {
    bgClassName: "bg-core-secondary-blue-300/10",
    borderColorClassName: "border-core-secondary-blue-200",
    textClassName: "text-core-secondary-blue-500",
  },
  neutral: {
    bgClassName: "bg-core-grey-100",
    borderColorClassName: "border-core-grey-200",
    textClassName: "text-core-grey-700",
  },
  success: {
    bgClassName: "bg-core-plunge-pool-50",
    borderColorClassName: "border-core-plunge-pool-200",
    textClassName: "text-core-plunge-pool-700",
  },
};
export type StatusChipVariant = keyof typeof STATUS_CHIP_VARIANTS;

type StatusChipProps = {
  children: ReactNode;
  className?: string;
  variant: StatusChipVariant;
};

export const StatusChip = ({ children, className, variant = "neutral" }: StatusChipProps) => {
  const style = STATUS_CHIP_VARIANTS[variant] ?? STATUS_CHIP_VARIANTS.neutral;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-ds-0-25x border border-solid px-2 py-1 font-medium capitalize font-ds-body-regular-xxs",
        style.bgClassName,
        style.borderColorClassName,
        style.textClassName,
        className
      )}
    >
      {children}
    </span>
  );
};
